<template>
  <div class="s_chat_right g-flex-column">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.title" :name="item.name"></el-tab-pane>
    </el-tabs>
    
    <div class="s-chat-right-bottom">
      <chat-right-info v-show="activeName === '0'" v-bind="$attrs" v-on="$listeners"/>

      <chat-right-quick v-show="activeName === '1'"/>
    </div>

  </div>
</template>

<script>
  import ChatRightInfo from '@/views/chat/ChatRightInfo.vue';
  import ChatRightQuick from '@/views/chat/ChatRightQuick.vue';
  export default {
    inheritAttrs: false, //不在组件中显示props

    components: { ChatRightInfo, ChatRightQuick }, 
    
    data() {
      return {
        activeName: '0',

        tabList: [ 
          { title: '客户', name: '0' },
          { title: '快捷', name: '1' },
        ],
      }
    },
    methods: {
      handleClick() {},
    }
  }
</script>

<style lang="scss">
.s_chat_right {
  min-width: 272px;
  max-width: 300px;
  width: 40%;
  background: $white;
  height: 100%;
  .el-tabs {
    max-height: 60px;
    height: 60px;
    line-height: 60px;
    .el-tabs__header {
      .el-tabs__nav-scroll {
        .el-tabs__active-bar {
          background: $mainBlue;
        }
        .el-tabs__item {
          padding: 0 20px;
          &.is-active {
            color: $mainBlue;
          }
        }
      }
    }
  }
  .s-chat-right-bottom {
    flex: 1;
    overflow-y: auto;
  }
}
</style>